"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pinoConsoleLogHandler = void 0;
var _ansis = _interopRequireDefault(require("ansis"));
var _SeverityLevels = require("../../types/SeverityLevels");
var _isObject = require("../isObject");
var _stringifyErrorObject = require("../stringifyErrorObject");
var _stringifyObject = require("../stringifyObject");
/* eslint-disable no-console -- this is console transport handler which is designed to use console */

const NEWLINE_CHAR = '\r\n';
// @ts-expect-error -- this won't fail anything, but will be defined when on edge
const isInEdgeRuntime = typeof EdgeRuntime === 'string';
const isInNodeRuntime = !isInEdgeRuntime && typeof window === 'undefined';
const levelToColoretteFunctionName = {
  [_SeverityLevels.SeverityLevels.INFO]: _ansis.default.blue,
  [_SeverityLevels.SeverityLevels.METRIC]: _ansis.default.green,
  [_SeverityLevels.SeverityLevels.ERROR]: _ansis.default.red,
  [_SeverityLevels.SeverityLevels.WARN]: _ansis.default.yellow,
  [_SeverityLevels.SeverityLevels.DEBUG]: _ansis.default.gray.bgWhite
};
let levelToConsoleMethod;
const formatTime = time => new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  fractionalSecondDigits: 3,
  hour12: false
}).format(new Date(time));
const logLevelToLabel = Object.fromEntries(Object.entries(_SeverityLevels.SeverityLevels));
const pinoConsoleLogHandler = ({
  time,
  msg: userMessage,
  level,
  ...properties
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- initialized here because of tests and mocking of console methods would not apply when defined globally
  levelToConsoleMethod ??= {
    [_SeverityLevels.SeverityLevels.INFO]: console.info,
    [_SeverityLevels.SeverityLevels.METRIC]: console.debug,
    [_SeverityLevels.SeverityLevels.ERROR]: console.error,
    [_SeverityLevels.SeverityLevels.WARN]: console.warn,
    [_SeverityLevels.SeverityLevels.DEBUG]: console.debug
  };

  // console.log({ time, userMessage, level, properties });
  const formattedTime = `[${formatTime(time)}]`;
  let logLinePrefix = `${formattedTime} (${logLevelToLabel[level]}):`;
  if (isInEdgeRuntime || isInNodeRuntime) {
    logLinePrefix = levelToColoretteFunctionName[level](logLinePrefix);
  }
  let logLine = `${logLinePrefix} ${userMessage}`;
  if (Object.keys(properties).length > 0) {
    if (isInNodeRuntime) {
      // Space to divide the metadata from the message
      logLine += ' ';

      // Checking that property "error" is an object should be enough - when copying to worker thread the error prototype is lost
      if ((0, _isObject.isObject)(properties.error)) {
        const {
          error,
          ...propertiesWithoutError
        } = properties;
        logLine += _ansis.default.dim((0, _stringifyObject.stringifyObject)(propertiesWithoutError, undefined, true));
        logLine += NEWLINE_CHAR;
        logLine += (0, _stringifyErrorObject.stringifyErrorObject)(error);
      } else {
        // Dim metadata a little bit for the user to easily search in the logs
        logLine += _ansis.default.dim((0, _stringifyObject.stringifyObject)(properties, undefined, true));
      }
    } else {
      // Add newline for browser only, because of readability
      logLine += NEWLINE_CHAR;
    }
  }
  const logParams = [logLine];

  // In browser we want to leverage native object searching
  // which is better than printing object itself
  if (!isInEdgeRuntime && !isInNodeRuntime) {
    logParams.push(properties);
  }

  // Use only console.log for node, because node could create trace for that log if specific method is used.
  const logMethodForLevel = isInNodeRuntime ? console.log : levelToConsoleMethod[level];
  logMethodForLevel(...logParams);
};
exports.pinoConsoleLogHandler = pinoConsoleLogHandler;
//# sourceMappingURL=pinoConsoleLogHandler.js.map